import { createTheme as a } from "./highrise984.mjs";
import e from "./highrise989.mjs";
import l from "./highrise998.mjs";
import i from "./highrise986.mjs";
import d from "./highrise987.mjs";
function c(o) {
  const {
    modalColor: r,
    textColor2: t,
    boxShadow3: m
  } = o;
  return {
    color: r,
    textColor: t,
    boxShadow: m
  };
}
const s = a({
  name: "Modal",
  common: d,
  peers: {
    Scrollbar: i,
    Dialog: l,
    Card: e
  },
  self: c
});
export {
  s as default,
  c as self
};
